const parallaxTargets = document.querySelectorAll('[data-parallax]');

const parallaxObserver = new IntersectionObserver(onIntersectParallax, {
  root: null, //ビューポート
  rootMargin: '0px 0px', //0でもpxつける,-50%で要素の中央で発火
  threshold: 0,
});
function onIntersectParallax(entries, observer) {
  //交差検知したもののなかで、isIntersectingがtrueのDOMを色を変える関数に渡す
  entries.forEach((entry) => {
    //entry.isIntersectingで発火。オブジェクト確認
    const parallaxElement = entry.target;
    if (entry.isIntersecting) {
      if ((parallaxElement.dataset.parallax = 'fired')) {
        parallaxAnime(parallaxElement);
      }
    } else {
    }
  });
}
function parallaxAnime(target) {
  window.addEventListener('scroll', () => {
    setPosition();
  });
  window.addEventListener('load', () => {
    setPosition();
  });
  window.addEventListener('resize', () => {
    setPosition();
  });
  function setPosition() {
    let targetRectTop = target.getBoundingClientRect().top;
    let parallaxSpeed = `${targetRectTop * -0.1}`;
    target.style.backgroundPositionY = `calc(50% - ${parallaxSpeed}px)`;
  }
}
if (parallaxTargets) {
  parallaxTargets.forEach((target) => {
    parallaxObserver.observe(target);
  });
}

// const
import Rellax from 'rellax';
//relax.js
const rellaxTitle = new Rellax('.-rellax_title', {
  speed: 1,
  center: true,
  wrapper: null,
  round: true,
  vertical: true,
  horizontal: false,
});

const rellaxTitlePage = new Rellax('.-rellax_title_page', {
  speed: 2,
  center: false,
  wrapper: null,
  round: true,
  vertical: true,
  horizontal: false,
});

const rellaxBg = new Rellax('.-rellax_bg', {
  speed: 3,
  center: false,
  wrapper: null,
  round: true,
  vertical: true,
  horizontal: false,
});
